import { defineStore } from 'pinia';
import { Logger } from '../middlewares/sentry.js';
import VideoService from '../services/VideoService.js';

export const useVideoStore = defineStore('coreVideos', {
  state: () => ({
    videos: {},
    isLoading: false,
  }),
  actions: {
    async loadVideos() {
      const NUM_OF_VDS = 5;
      let numAddedVideos = -1;

      if (this.isLoading === false) {
        this.isLoading = true;
        numAddedVideos = 0;

        const listOfNames = [];
        for (const video in this.videos) {
          if (this.videos.hasOwnProperty(video)) {
            listOfNames.push(video);
          }
        }

        try {
          const resp = await VideoService.getGalleryVideosInfo(
            NUM_OF_VDS,
            listOfNames,
          );

          numAddedVideos = resp.data.length;
          for (const file of resp.data) {
            this.videos[file.name] = {
              url: VideoService.getManifestUrlByName(file.name),
            };
          }
        } catch (err) {
          Logger.error(err);
        }

        this.isLoading = false;
      }

      return numAddedVideos;
    },
    getElements(n, numberOfColumns) {
      return Object.keys(this.videos)
        .filter((_, index) => index % numberOfColumns === n)
        .map((key) => this.videos[key]);
    },
  },
  getters: {
    numberOfImages: (state) => Object.keys(state.videos).length,
  },
});
